export default __webpack_public_path__ + "static/media/image_2.1bb7a2c3.jpg";